import { EntityModel } from '@/interfaces'
import {
  ALL_ONLINE_PAYMENTS_QUERY,
  CREATE_ONLINE_PAYMENT_MUTATION,
  DELETE_ONLINE_PAYMENT_MUTATION,
  FORCE_DELETE_ONLINE_PAYMENT_MUTATION,
  SINGLE_ONLINE_PAYMENT_QUERY,
  UPDATE_ONLINE_PAYMENT_MUTATION,
} from './graphql'
import tenantEntity from '@/entities/tenant/entity'

const onlinePaymentModel: EntityModel = {
  name: 'onlinePayment',
  namePlural: 'onlinePayments',
  uniqueName: 'onlinePayment',
  uniqueNamePlural: 'onlinePayments',
  path: 'payment/online_payment',
  baseUrl: '/payment/online_payments',
  translationPrefix: 'entities:onlinePayment.',
  getDisplayName: (values: any) => {
    return 'ONLINE PAYMENT'
  },
  gql: {
    getAll: ALL_ONLINE_PAYMENTS_QUERY,
    getSingle: SINGLE_ONLINE_PAYMENT_QUERY,
    create: CREATE_ONLINE_PAYMENT_MUTATION,
    update: UPDATE_ONLINE_PAYMENT_MUTATION,
    delete: DELETE_ONLINE_PAYMENT_MUTATION,
    forceDelete: FORCE_DELETE_ONLINE_PAYMENT_MUTATION,
  },
  attributes: {
    transactionId: {
      name: 'transactionId',
      label: 'entities:onlinePayment.attributes.transactionId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    tenant: {
      name: 'tenant',
      label: 'entities:onlinePayment.attributes.tenant.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    transactionStatus: {
      name: 'transactionStatus',
      label: 'entities:onlinePayment.attributes.transactionStatus.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'initialized',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    submittedToBackoffice: {
      name: 'submittedToBackoffice',
      label: 'entities:onlinePayment.attributes.submittedToBackoffice.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'date',
      validationType: 'string',
      validations: [],
    },
    statusPayload: {
      name: 'statusPayload',
      label: 'entities:onlinePayment.attributes.statusPayload.label',
      type: 'value',
      dataType: '{ [x: string]: any }',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default onlinePaymentModel
